import PropTypes from "prop-types"
import React, { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { matchPath, useLocation } from "react-router"
import { NavLink } from "react-router-dom"

import { capitalizeFirstLetter } from "../../utils/utils"

const BreadCrumbs = ({ routes , currentPageTitle }) => {
    const { t } = useTranslation()
    const location = useLocation()
    const pathnames = location.pathname?.split("/").filter((x) => x)
    if(!pathnames?.includes("auto-approval-rules")) {
        sessionStorage.removeItem("masterData")
    }
    let generateDynamicBreadCurms = false
    let isDynamicStaticNumber = false
    let currentRoute
    routes.forEach((parRoute) => {
        if (!currentRoute) {
            currentRoute = parRoute.children.find((route) =>
                matchPath(route.path, location.pathname)
            )
        }
    })
    generateDynamicBreadCurms = currentRoute?.isDynamicBreadCurm || false
    isDynamicStaticNumber = currentRoute?.isDynamicStaticNumber || false
    let dynamicPath = useMemo(() => {
        if (currentRoute && generateDynamicBreadCurms) {
            return currentRoute.breadcrumb.split("/")
        }
    }, [currentRoute, generateDynamicBreadCurms])

    const findRouteName = (pathname, routes) => {
        let matchedRoute
        matchedRoute = routes.map((parRoute) => {
            const filterRoute = parRoute.children.find((route) =>
                matchPath(route.path, pathname)
            )
            return filterRoute
        })
        return matchedRoute.find((item) => item !== undefined)
    }

    const pageTitle = (currentRoute) =>{
        let title = currentPageTitle
        if(currentRoute?.path === "/order/orderUpload" || currentRoute?.path === "/order/orderHistory" )
        {
            title=  t("breadCrumbs.orderManagement") 
        }
        return title
    }
       
    return (
        <nav className="bread-crumb">
            <ul className="flex text-xs py-3 space-x-1 no-print">
                <li className="flex items-center m-0">
                    { pathnames.length > 0 ? (
                        <>
                            <NavLink to="/dashboard" className="text-primary-50">
                                { t("breadCrumbs.home") }
                            </NavLink>
                            <span className="mx-1">/</span>
                        </>
                    ) : (
                        <>
                            <NavLink to="/dashboard" className="text-primary-50">
                                { t("breadCrumbs.home") }
                            </NavLink>
                            <li className="flex items-center">
                                <span className="mx-1">/</span>
                                <span className="text-secondary-200">
                                    { t("Home.foundationData") }
                                </span>
                            </li>
                        </>
                    ) }
                </li>
                { !generateDynamicBreadCurms &&
          pathnames?.map((value, index) => {
              if( (value === "orderHistory" || value === "orderUpload") && index === 1 ){
                  return
              }
              const last = index === pathnames.length - 1
              const to =  `/${pathnames.slice(0, index + 1).join("/")}`
              const toWarrantyExternaluaer = "/warranty/new-ticket"
              const routeName = findRouteName(to, routes)
              return last ? (
                  isDynamicStaticNumber ? <li key={ value } className="flex items-center">
                      <span className="text-secondary-200">
                          {   capitalizeFirstLetter(currentRoute?.isShowFromState ? (currentPageTitle || "") : 
                              decodeURI(pathnames[index]))  }
                      </span>
                  </li> :  <li key={ value } className="flex items-center">                 
                      <span className="text-secondary-200">
                          { t(`breadCrumbs.${routeName?.breadcrumb}`) }
                      </span>
                  </li>
              ) : (
                  routeName?.breadcrumb && (
                      <li key={ value } className="flex items-center">
                          <NavLink to={ currentRoute.isexternalUserLink ? toWarrantyExternaluaer : to } className="text-primary-50">
                              { t(`breadCrumbs.${routeName?.breadcrumb}`) }
                          </NavLink>
                          <span className="mx-1">/</span>
                      </li>
                  )
              )
          }) }
                { generateDynamicBreadCurms &&
          dynamicPath?.map((value, index) => {
              const last = index === dynamicPath.length - 1
              const to = (decodeURI(pathnames[index])) == "warranty" 
                  ? "/warranty/warranty-management" : `/${dynamicPath.slice(0, index + 1).join("/")}`
              const routeName = findRouteName(to, routes)
              return (
                  <>
                      { value.trim() !== "" &&
                  (last ? (
                      <li key={ value } className="flex items-center">
                          <span className="text-secondary-200">
                              { capitalizeFirstLetter(decodeURI(pathnames[index])) ===
                        "Training"
                                  ? t(
                                      `breadCrumbs.${capitalizeFirstLetter(
                                          decodeURI(pathnames[index])
                                      )}`
                                  ):
                                  capitalizeFirstLetter(currentRoute?.isShowFromState ? (pageTitle(currentRoute) || "") :
                                      decodeURI(pathnames[index]))
                              }
                          </span>
                      </li>
                  ) : (
                      <li key={ value } className="flex items-center">
                          <NavLink to={ to } className="text-primary-50">
                              { (routeName?.breadcrumb == "training"
                                  ? capitalizeFirstLetter(
                                      t(`breadCrumbs.${routeName?.breadcrumb}`)
                                  )
                                  :
                                  capitalizeFirstLetter(decodeURI(pathnames[index])) === "Newsandbulletin" ?
                                      t(
                                          `breadCrumbs.${decodeURI(pathnames[index])}`
                                      ) 
                                      : (decodeURI(pathnames[index])) == "warranty"
                                          ? capitalizeFirstLetter(
                                              t(`breadCrumbs.${decodeURI(pathnames[index])}`)
                                          )
                                          : capitalizeFirstLetter(routeName?.breadcrumb))
                              }
                          </NavLink>
                          <span className="mx-1">/</span>
                      </li>
                  )) }
                  </>
              )
          }) }
            </ul>
        </nav>
    )
}

BreadCrumbs.propTypes = {
    currentPageTitle: PropTypes.any,
    routes: PropTypes.any
}

export default BreadCrumbs
